// extracted by mini-css-extract-plugin
export var container = "AmountInputSkeleton-module--container--4c582";
export var input = "AmountInputSkeleton-module--input--98385";
export var preset = "AmountInputSkeleton-module--preset--6b5bf";
export var presets = "AmountInputSkeleton-module--presets--a3113";